// extracted by mini-css-extract-plugin
export var chevron = "_1x-d";
export var disabled = "_1x-b";
export var error = "_1x-c";
export var hideBorder = "_1x-1";
export var icon = "_1x-e";
export var input = "_1x-0";
export var large = "_1x-f";
export var open = "_1x-9";
export var placeholder = "_1x-a";
export var regular = "_1x-5";
export var singleRowInput = "_1x-2";
export var singleSelectInput = "_1x-3 _1x-0";
export var small = "_1x-4";
export var spinnerContainer = "_1x-i";
export var tag = "_1x-7";
export var tagsContainer = "_1x-8";
export var tagsInput = "_1x-6 _1x-0";
export var xSmall = "_1x-g";
export var xxSmall = "_1x-h";